/**
 * 전화번호 포맷팅 유틸리티
 *
 * - 입력 시 자동 하이픈 삽입 (010-1234-5678)
 * - API 전송 시 하이픈 제거 (01012345678)
 */

/**
 * 전화번호 입력값에 하이픈 자동 삽입 (010-1234-5678)
 *
 * "010" 입력 시 바로 "010-"이 나타나서 다음 숫자를 바로 입력할 수 있다.
 * 백스페이스 시 하이픈이 다시 생기는 문제를 방지하기 위해 prevValue를 비교한다.
 *
 * @param value    현재 입력값 (e.target.value)
 * @param prevValue 이전 상태값 (삭제 감지용)
 */
export function formatPhoneInput(value: string, prevValue: string = ''): string {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  const isDeleting = value.length < prevValue.length

  if (digits.length < 3) return digits
  // 010까지 입력하면 바로 하이픈 표시 (삭제 중이면 하이픈 없이 숫자만)
  if (digits.length === 3) return isDeleting ? digits : `${digits}-`
  if (digits.length < 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`
  // 010-1234까지 입력하면 바로 두 번째 하이픈 표시
  if (digits.length === 7) return isDeleting ? `${digits.slice(0, 3)}-${digits.slice(3)}` : `${digits.slice(0, 3)}-${digits.slice(3)}-`
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`
}

/**
 * 전화번호에서 하이픈 제거 (API 전송용)
 */
export function stripPhone(phone: string): string {
  return phone.replace(/\D/g, '')
}

/**
 * 전화번호 표시용 포맷팅 (01012345678 → 010-1234-5678)
 *
 * DB에 숫자만 저장된 전화번호를 사람이 읽기 좋게 변환한다.
 * 이미 하이픈이 포함되어 있거나 형식이 다르면 숫자만 추출 후 포맷팅.
 */
export function formatPhoneDisplay(phone: string): string {
  const digits = phone.replace(/\D/g, '')
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
  }
  return phone
}
